export default __webpack_public_path__ + "static/media/640_portfolio02-fr-mobile.88a8a63f.png";